import './Indicator.css';

export default function Indicator({ data_ok, verify, name, value, message_good, message_bad, message_unknown, cls_active, cls_inactive }) {
    return (
        <div className="indicator-wrapper ">
            <div className={'indicator-box ' +
                (
                    verify !== undefined && verify === true ?
                        data_ok === true ?
                            value === false ?
                                cls_inactive
                                :
                                cls_active
                            : "unverify"
                        : "unverify"

                )}>
                <div className='indicator-box-in' >
                    <div className='indicator-header'>{name}</div >
                    <div>{verify}</div>
                    {
                        data_ok === true && verify === true ?
                            <div className='indicator-header'>
                                {
                                    value === true ?
                                        message_good !== "" ?
                                            message_good
                                            :
                                            null
                                        :
                                        value !== undefined ?
                                            message_bad
                                            :
                                            message_unknown
                                }
                            </div >
                            :
                            <div className='indicator-header'>{message_unknown}</div >
                    }
                </div>
            </div>
        </div >
    )

}
